import React, {useState, useEffect, useContext} from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AddIcon from '@material-ui/icons/Add'
import {Button, Grid, Divider, Typography, Link} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import {makeStyles} from '@material-ui/core/styles'
import ErrorMessage from '../../../components/ErrorMessage'
import {ToastContext} from '../../../App'
import {useFormReducerHook} from '../../../utils/customHooks'
import Loader from '../../../components/Loader'
import {MyAccountContext} from '../../containers/Layout'
import {
    deleteAPIData,
    getClientProgramAPIData,
    getAPIData,
} from '../../services/myaccount'
//import {myAccountSchema, is_hide_auth_type} from '../../utils/constants'
import FormBuilder from '../../../components/FormBuilder'
import i18next from 'i18next'
import {TOAST_VARIANT, pageList, GlobalSetting} from '../../../utils/constants'
import _ from 'lodash'
import TableBuilder from '../../../components/TableBuilder'
import get from 'get-value'
import set from 'set-value'
import ConfirmationBox from '../../../components/ConfirmationBox'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const OrganizationSectionForm = props => {
    const {showToast} = useContext(ToastContext)
    const [entityChange, setEntityChange] = useState(null)
    const [programChange, setProgramChange] = useState(null)
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
        // validationData,
        updateEntireFormData,
    } = useFormReducerHook()

    useEffect(() => {
        updateEntireFormData(props.obj.formData)
    }, [])

    // useEffect(() => {
    //     updateEntireFormData(props.obj.formData)
    // }, [props.obj.formData])

    useEffect(() => {
        if (
            (props.openProgramDialog && props.dialogProgramId) ||
            props.programEdit
            // (!props.openProgramDialog && props.programEdit)
        ) {
            updateEntireFormData(props.obj.formData)
        }
    }, [props.obj, props.programEdit])

    useEffect(() => {
        let valueCount = 0
        for (const key in formData) {
            if (
                formData.hasOwnProperty(key) &&
                formData[key] &&
                formData[key].type !== 'boolean'
            ) {
                if (formData[key]) valueCount += 1
                //do something with value;
            }
        }

        if (props.validateTrigger) {
            const isValid = validate()
            const orgId = props.obj && props.obj.orgId && props.obj.orgId
            props.addFormData(orgId, formData, isValid)
            // formData, isValid, validateTrigger = false
        }
    }, [props.validateTrigger])

    useEffect(() => {
        const oldEntityChange = entityChange
        var isEdit = false
        let progID = null
        let currenrobj = []
        props.userDetails &&
            props.userDetails.programaccess &&
            props.userDetails.programaccess.map(detail => {
                progID =
                    (props.openProgramDialog && props.dialogProgramId) ||
                    props.programEdit
                if (progID && detail.clientprogram.clientprogramid === progID) {
                    detail.oldorganizationaccess.map(oldOrg => {
                        currenrobj.push(oldOrg.cliententityid.toString())
                    })
                }
            })

        if (
            formData.cliententity &&
            formData.cliententity.cliententityid &&
            !currenrobj.includes(formData.cliententity.cliententityid)
        ) {
            if (
                oldEntityChange &&
                !_.isEqual(oldEntityChange, formData.cliententity.cliententityid)
            ) {
                isEdit = true
            }
        }

        if (isEdit) {
            setFormData('clinicians', 'all')
            setFormData('locations', 'all')
        }

        const orgId = props.obj && props.obj.orgId && props.obj.orgId
        if (props.org && formData.cliententity && formData.cliententity.cliententityid) {
            const orgIsExist = props.org.filter(p => {
                return (
                    p.orgId !== orgId &&
                    p.isdeleted === false &&
                    p.formData.cliententity.cliententityid ===
                        formData.cliententity.cliententityid
                )
            })

            if (orgIsExist.length) {
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: 'Selected organization already exist in another access.',
                })
                let clearOrg = JSON.parse(JSON.stringify(formData))
                clearOrg.cliententity = {}
                updateEntireFormData(clearOrg)
            } else {
                props.addFormData(orgId, formData, false)
            }
        } else if (props.clientProgramId && props.org && formData.cliententity) {
            props.addFormData(orgId, formData, false)
        }
        const newEntityChange =
            formData.cliententity && formData.cliententity.cliententityid
                ? formData.cliententity.cliententityid
                : null
        setEntityChange(newEntityChange)
    }, [formData.cliententity])

    useEffect(() => {
        const newProgramChange = props.clientProgramId ? props.clientProgramId : null
        setProgramChange(newProgramChange)
        const isEdit =
            (props.openProgramDialog && props.dialogProgramId) || props.programEdit
        //(!props.openProgramDialog && props.programEdit)
        if (!isEdit) {
            setFormData('cliententity', {})
            setFormData('clinicians', 'all')
            setFormData('locations', 'all')
        }
    }, [props.clientProgramId])

    const actionMethods = (type, payload) => {
        switch (type) {
            case 'Organization':
                const isEdit =
                    (props.openProgramDialog && props.dialogProgramId) ||
                    props.programEdit
                //(!props.openProgramDialog && props.programEdit)
                if (payload.length === 1 && !isEdit) {
                    setEntityChange(payload[0].value)
                    setFormData('cliententity.cliententityid', payload[0].value)
                    setFormData('cliententity.name', payload[0].label)
                } else if (payload.length === 0) {
                    setEntityChange(null)
                    setFormData('cliententity', {})
                }
                break
            default:
                break
        }

        props.actionMethods(type, payload)
    }

    if (programChange === 8 || props.clientProgramId === 8) {
        let edSchema = {
            fieldName: 'Emergency Departments',
            componentType: 'MyAccountRadioDropdown',
            columnName: 'eds',
            cssClass: 'col-lg-4 col-md-6 um-org-loc-dtl',
            dropdownPlaceholder: 'Search & Select Emergency Departments',
            radioLabel: 'All Emergency Departments Selected',
            endPoint: 'cliententity/demographicslist',
            getOptionsData: true,
            dependentKey: ['clientprogram', 'parentcliententity'],
            dependentKeyval: {},
            validations: [
                {
                    type: 'isRequired',
                    errorText: 'Emergency Department is required',
                },
            ],
        }

        props.fields.map(data => {
            data.value.map((data1, index) => {
                if (data1.columnName === 'locations') {
                    data.value[index] = edSchema
                }
            })
        })
    } else {
        props.fields.map(data => {
            data.value.map((data1, index) => {
                if (data1.columnName === 'eds') {
                    data.value[index] = {
                        fieldName: 'Locations',
                        componentType: 'MyAccountRadioDropdown',
                        columnName: 'locations',
                        cssClass: 'col-lg-4 col-md-6 um-org-loc-dtl',
                        dropdownPlaceholder: 'Search & Select Locations',
                        radioLabel: 'All Locations Selected',
                        endPoint: 'cliententity/location',
                        getOptionsData: true,
                        dependentKey: ['clientprogram', 'cliententity'],
                        dependentKeyval: {},
                        validations: [
                            {
                                type: 'isRequired',
                                errorText: 'Location is required',
                            },
                        ],
                    }
                }
            })
        })
    }

    var fields = props.fields
    if (props.fields) {
        fields.map(data => {
            _.map(data.value, data1 => {
                if (data1.dependentKey) {
                    if (programChange) {
                        if (
                            data1.dependentKey.length === 1 &&
                            data1.dependentKey.includes('clientprogram')
                        ) {
                            data1.dependentKeyval = {
                                'client-program-id': programChange,
                            }
                        } else if (
                            data1.dependentKey.length === 1 &&
                            data1.dependentKey.includes('cliententity') &&
                            (entityChange ||
                                (formData.cliententity &&
                                    formData.cliententity.cliententityid))
                        ) {
                            data1.dependentKeyval = {
                                'client-entity-id':
                                    formData.cliententity &&
                                    formData.cliententity.cliententityid
                                        ? formData.cliententity.cliententityid
                                        : entityChange,
                            }
                        } else if (
                            data1.dependentKey.length === 2 &&
                            (entityChange ||
                                (formData.cliententity &&
                                    formData.cliententity.cliententityid))
                        ) {
                            if (
                                data1.dependentKey.includes('cliententity') &&
                                data1.dependentKey.includes('clientprogram')
                            ) {
                                data1.dependentKeyval = {
                                    'client-entity-id':
                                        formData.cliententity &&
                                        formData.cliententity.cliententityid
                                            ? formData.cliententity.cliententityid
                                            : entityChange,
                                    'client-program-id': programChange,
                                }
                            } else if (
                                data1.dependentKey.includes('parentcliententity') &&
                                data1.dependentKey.includes('clientprogram')
                            ) {
                                data1.dependentKeyval = {
                                    'parent-client-entity-id':
                                        formData.cliententity &&
                                        formData.cliententity.cliententityid
                                            ? formData.cliententity.cliententityid
                                            : entityChange,
                                    'client-program-id': programChange,
                                }
                            }
                        } else {
                            data1.dependentKeyval = {}
                        }
                    } else {
                        data1.dependentKeyval = {}
                    }
                }
            })
        })
    }

    let orgCount = 0
    _.map(props.org, org => {
        !org.isdeleted && orgCount++
    })

    return (
        <Grid container spacing={3} className="um-org-dtl__row">
            {orgCount > 1 && (
                <Grid item xs className="delete-btn__wrapper">
                    <span
                        className={'icon_btn__span delete-btn disabled'}
                        title="Delete"
                        onClick={() => props.removeOrganization(props.obj.orgId)}
                    >
                        <FontAwesomeIcon
                            icon={['fal', 'trash-alt']}
                            className="action_icons disabled"
                            title="Delete"
                            size="lg"
                            color="grey"
                        ></FontAwesomeIcon>
                    </span>
                </Grid>
            )}

            <Grid item xs={12} className="um-org-dtl__content">
                <Grid container spacing={3}>
                    <Grid item xs={12} className="add-org-ttl__div">
                        <Typography variant="h5" className="accordion_title_h5">
                            Organization
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className="add-org-form__div">
                        <FormBuilder
                            fields={props.fields}
                            formData={formData}
                            setFormData={setFormData}
                            errorsData={errorsData}
                            updateValidation={updateValidationData}
                            actionMethods={actionMethods}
                            // loading={loading}
                            // setFormDataChanged={setFormDataChanged}
                        />
                        <Divider />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

const ExpandingPanelForm = props => {
    const {showToast} = useContext(ToastContext)
    const {clientObject, myAccountSchema} = useContext(MyAccountContext)
    const [programChange, setProgramChange] = useState(null)
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
        validationData,
        updateEntireFormData,
    } = useFormReducerHook()
    const [programData, setProgramData] = useState({})
    const [roleData, setRoleData] = useState({})
    const [organizationData, setOrganizationData] = useState({})
    const [authenticationTypeData, setAuthenticationTypeData] = useState({})
    const [formFields, setFormfields] = useState([...props.fields])
    const [loginMaxLength, setLoginMaxLength] = useState(100)
    const [multiselectRole, setMultiselectRole] = useState(false)
    const [programCustomMsg, setProgramCustomMsg] = useState(null)
    const [multifaField, setMultifaField] = useState({})

    const actionMethods = (type, payload) => {
        const isEdit = props.openProgramDialog ? props.dialogProgramId : props.programEdit
        switch (type) {
            case 'Program':
                setProgramData(payload)
                if (payload.length > 0) {
                    props.setIsMultiProgram && props.setIsMultiProgram(true)
                }

                if (payload.length === 1 && !isEdit) {
                    setProgramChange(payload[0].value)
                    // setFormData('clientprogram.clientprogramid', payload[0].value)
                    // setFormData('clientprogram.name', payload[0].label)
                    setFormData('clientprogram', {
                        clientprogramid: payload[0].value,
                        name: payload[0].label,
                        allowmultipleroleselect: payload[0].obj.allowmultipleroleselect,
                    })
                } else if (payload.length === 0) {
                    setProgramChange(null)
                    setFormData('clientprogram', {})
                }
                if (props.savedProgramList) {
                    const callfun = async () => {
                        let filterData = await payload
                            .map(p => {
                                return (
                                    (props.savedProgramList.indexOf(p.value) === -1 &&
                                        p) ||
                                    null
                                )
                            })
                            .filter(f => f !== null)
                        let setData = _.cloneDeep(props.sectionProps)
                        set(
                            setData.accessFormStruct,
                            setData.accessFormStruct.programdropdownpath + '.fetchData',
                            false
                        )
                        set(
                            setData.accessFormStruct,
                            setData.accessFormStruct.programdropdownpath + '.data',
                            filterData
                        )
                        props.setDialogSectionData(setData)
                        if (filterData.length === 1 && !isEdit) {
                            setProgramChange(filterData[0].value)
                            // setFormData(
                            //     'clientprogram.clientprogramid',
                            //     filterData[0].value
                            // )
                            // setFormData('clientprogram.name', filterData[0].label)
                            setFormData('clientprogram', {
                                clientprogramid: filterData[0].value,
                                name: filterData[0].label,
                                allowmultipleroleselect:
                                    filterData[0].obj.allowmultipleroleselect,
                            })
                        }
                    }
                    callfun()
                }
                break
            case 'Role':
                setRoleData(payload)
                if (payload.length === 1 && !isEdit) {
                    if (multiselectRole) {
                        setFormData('userrole', [
                            {
                                clientprogramrolemappingid: payload[0].value,
                                name: payload[0].label,
                            },
                        ])
                    } else {
                        setFormData(
                            'userrole.clientprogramrolemappingid',
                            payload[0].value
                        )
                        setFormData('userrole.name', payload[0].label)
                    }
                } else if (payload.length === 0) setFormData('userrole', {})

                break
            case 'Organization':
                setOrganizationData(payload)
                break
            case 'AccessDenied':
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: 'Access denied.',
                })
                if (props.openProgramDialog && props.dialogProgramId)
                    props.cancelProgramDialog()
                else if (props.programEdit) props.setRouter(props.backrouter || 'user')
                break
            default:
                break
        }
    }

    useEffect(() => {
        setFormfields(props.fields)
    }, [props.fields])

    useEffect(() => {
        updateEntireFormData(props.obj.formData)
    }, [])

    useEffect(() => {
        if ((props.openProgramDialog && props.dialogProgramId) || props.programEdit) {
            updateEntireFormData(props.obj.formData)
        }
    }, [props.obj, props.programEdit])

    useEffect(() => {
        // console.log('programaccessdata', formData)
        let valueCount = 0
        for (const key in formData) {
            if (
                formData.hasOwnProperty(key) &&
                formData[key] &&
                formData[key].type !== 'boolean'
            ) {
                if (formData[key]) valueCount += 1
                //do something with value;
            }
        }
        if (props.validateTrigger) {
            if (validate()) {
                if (props.actionFrom === 'usersave') props.handleSave(true, formData)
                else if (
                    props.actionFrom === 'newaccess' ||
                    props.actionFrom === 'saveaccess'
                )
                    props.handleProvideAccess(props.actionFrom, true, formData)
                else if (props.actionFrom === 'accesscollapse')
                    props.mapSectionData(formData)
            } else {
                if (props.actionFrom === 'usersave') props.handleSave(false, formData)
                else if (
                    props.actionFrom === 'newaccess' ||
                    props.actionFrom === 'saveaccess'
                )
                    props.handleProvideAccess(props.actionFrom, false, formData)
            }
            props.setValidateTrigger(true, '', '')
        }
    }, [props.validateTrigger])

    useEffect(() => {
        const isEdit =
            (props.openProgramDialog && props.dialogProgramId) || props.programEdit
        //(!props.openProgramDialog && props.programEdit)
        if (!isEdit) {
            setFormData('userrole', {})
            setFormData('authenticationtype', {})
            setFormData(' multifa', {
                value: false,
                label: 'No',
                obj: {value: false, label: 'No'},
            })
        }
        if (
            formData.clientprogram &&
            formData.clientprogram.allowmultipleroleselect !== undefined &&
            formData.clientprogram.allowmultipleroleselect !== null
        ) {
            setMultiselectRole(formData.clientprogram.allowmultipleroleselect)
        } else {
            setMultiselectRole(false)
        }
        // setFormData('userrole', {})
        const newProgramChange =
            formData.clientprogram && formData.clientprogram.clientprogramid
                ? formData.clientprogram.clientprogramid
                : null
        setProgramChange(newProgramChange)

        getAuthecationModeByProgram(
            formData.clientprogram && formData.clientprogram.clientprogramid
                ? formData.clientprogram.clientprogramid
                : ''
        )

        let setData = _.cloneDeep(props.sectionProps)
        if (setData.accessFormStruct.multifaProgramObject) {
            let cProgramid =
                (formData.clientprogram && formData.clientprogram.clientprogramid) || 0
            let programObjForMultiFactor =
                setData.accessFormStruct.multifaProgramObject &&
                setData.accessFormStruct.multifaProgramObject.length > 0
                    ? setData.accessFormStruct.multifaProgramObject.filter(data => {
                          return data.clientProgramId === cProgramid
                      })
                    : null

            if (programObjForMultiFactor && programObjForMultiFactor.length > 0) {
                if (!isEdit) {
                    setFormData('multifa', {
                        value: programObjForMultiFactor[0].defaultValue,
                        label: programObjForMultiFactor[0].defaultValue ? 'Yes' : 'No',
                        obj: {
                            value: programObjForMultiFactor[0].defaultValue,
                            label: programObjForMultiFactor[0].defaultValue
                                ? 'Yes'
                                : 'No',
                        },
                    })
                }
                setMultifaField({
                    isHide: programObjForMultiFactor[0].isHide,
                    isDisabled: programObjForMultiFactor[0].isDisabled,
                })
            } else {
                setMultifaField(null)
            }
        }
        if (formData.clientprogram && formData.clientprogram.clientprogramid) {
            let programIdForCustomMsg =
                setData.accessFormStruct.programIdForCustomMsg &&
                setData.accessFormStruct.programIdForCustomMsg.length > 0
                    ? setData.accessFormStruct.programIdForCustomMsg.filter(
                          data =>
                              data.id.toString() ===
                              formData.clientprogram.clientprogramid.toString()
                      )
                    : null

            if (programIdForCustomMsg && programIdForCustomMsg.length > 0) {
                setProgramCustomMsg({
                    msg: programIdForCustomMsg[0].msg,
                })
            } else {
                setProgramCustomMsg(null)
            }
        } else {
            setProgramCustomMsg(null)
        }
    }, [formData.clientprogram && formData.clientprogram.clientprogramid])

    useEffect(() => {
        let isDisable = false
        let loginName = ''
        if (authenticationTypeData.length > 1) {
            const filterData = props.accessData.filter(
                item =>
                    (item.accessId !== props.activeSection || !props.dialogProgramId) &&
                    formData.authenticationtype.authenticationtypeid ===
                        item.formData.authenticationtype.authenticationtypeid
            )
            if (
                filterData.length > 0 &&
                formData.authenticationtype.authenticationtypeid === 1
            ) {
                isDisable = true
                loginName = filterData[0].formData.loginname
            }
            if (
                formData.authenticationtype.authenticationtypeid === 1 &&
                props.userid &&
                props.ADLoginName
            ) {
                isDisable = true
                loginName = props.ADLoginName
            }
            const _progID = props.openProgramDialog
                ? props.dialogProgramId
                : props.programEdit
            const nonAdLoginData = props.accessData.filter(
                item =>
                    item.accessId === props.activeSection &&
                    formData.authenticationtype.authenticationtypeid ===
                        item.formData.authenticationtype.authenticationtypeid &&
                    formData.authenticationtype.authenticationtypeid !== 1
            )
            if (_progID && props.userid && nonAdLoginData.length > 0) {
                isDisable = true
                loginName = nonAdLoginData[0].formData.loginname
            }
            setFormData('loginname', loginName)
            setFormfields(
                formFields.map(item => {
                    const _val = item.value.map(val => {
                        if (val.fieldName === 'Program Login Name') {
                            if (val.hasOwnProperty('disabled'))
                                return {...val, disabled: isDisable}
                            else return {...val, isDisabled: isDisable}
                        } else return {...val}
                    })
                    return {...item, value: _val}
                })
            )
        }

        let setData = _.cloneDeep(props.sectionProps)
        let loginErrorText = setData.accessFormStruct.loginValidationOther.errorMsg
        let loginRegexValue = setData.accessFormStruct.loginValidationOther.regex
        if (
            formData.authenticationtype &&
            formData.authenticationtype.authenticationtypeid === 1
        ) {
            // AD validation
            setLoginMaxLength(setData.accessFormStruct.loginValidationAD.maxLength)
            loginErrorText = setData.accessFormStruct.loginValidationAD.errorMsg
            loginRegexValue = setData.accessFormStruct.loginValidationAD.regex
        } else {
            setLoginMaxLength(setData.accessFormStruct.loginValidationOther.maxLength)
        }

        let newValidationData = validationData
        if (
            newValidationData &&
            newValidationData.loginname &&
            newValidationData.loginname.length > 0
        ) {
            newValidationData.loginname.map(validation => {
                if (
                    authenticationTypeData.length > 1 &&
                    isDisable &&
                    validation.internalFlag &&
                    validation.internalFlag === 'edit'
                ) {
                    validation.errorText = ''
                    validation.value = ''
                } else if (
                    formFields[1].value[1].disabled &&
                    validation.internalFlag &&
                    validation.internalFlag === 'edit'
                ) {
                    if (authenticationTypeData && authenticationTypeData.length > 1) {
                        validation.errorText = loginErrorText
                        validation.value = loginRegexValue
                    } else {
                        validation.errorText = ''
                        validation.value = ''
                    }
                } else if (
                    validation.internalFlag &&
                    validation.internalFlag === 'edit'
                ) {
                    validation.errorText = loginErrorText
                    validation.value = loginRegexValue
                }
            })
            updateValidationData(newValidationData)
        }
    }, [formData.authenticationtype && formData.authenticationtype.authenticationtypeid])

    useEffect(() => {
        if (props.programEdit) setProgramChange(props.programEdit)
    }, [props.programEdit])

    const getAuthecationModeByProgram = programId => {
        const _progID = props.openProgramDialog
            ? props.dialogProgramId
            : props.programEdit
        // console.log('_progID', _progID)
        if (!(_progID && Number.isInteger(_progID))) {
            setFormData('loginname', '')
            setFormfields(
                formFields.map(item => {
                    const _val = item.value.map(val => {
                        if (val.fieldName === 'Program Login Name') {
                            if (val.hasOwnProperty('disabled'))
                                return {...val, disabled: false}
                            else return {...val, isDisabled: false}
                        } else return {...val}
                    })
                    return {...item, value: _val}
                })
            )
        }
        const callApi = async () => {
            var apiData = await getAPIData(
                'clientprogram/authenticationtype',
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                    'client-program-id': programId,
                }
            )
            if (apiData && apiData.authenticationtype) {
                const authenticationtype = apiData.authenticationtype
                let authenticationTypeOptions = []
                authenticationtype.forEach(element => {
                    authenticationTypeOptions.push({
                        value: element.authenticationtypeid,
                        label: element.name,
                        obj: {...element},
                    })
                })
                setAuthenticationTypeData(authenticationTypeOptions)

                if (
                    (authenticationtype.length === 1 &&
                        authenticationtype[0].authenticationtypeid === 1) ||
                    myAccountSchema.is_hide_auth_type
                ) {
                    const filterData = props.accessData.filter(
                        item =>
                            (item.accessId !== props.activeSection ||
                                !props.dialogProgramId) &&
                            authenticationtype[0].authenticationtypeid ===
                                item.formData.authenticationtype.authenticationtypeid
                    )
                    if (props.userid && props.ADLoginName) {
                        setFormData('loginname', props.ADLoginName)
                        setFormfields(
                            formFields.map(item => {
                                const _val = item.value.map(val => {
                                    if (val.fieldName === 'Program Login Name') {
                                        if (val.hasOwnProperty('disabled'))
                                            return {...val, disabled: true}
                                        else return {...val, isDisabled: true}
                                    } else return {...val}
                                })
                                return {...item, value: _val}
                            })
                        )
                    }
                    if (filterData.length > 0) {
                        setFormData('loginname', filterData[0].formData.loginname)
                        setFormfields(
                            formFields.map(item => {
                                const _val = item.value.map(val => {
                                    if (val.fieldName === 'Program Login Name') {
                                        if (val.hasOwnProperty('disabled'))
                                            return {...val, disabled: true}
                                        else return {...val, isDisabled: true}
                                    } else return {...val}
                                })
                                return {...item, value: _val}
                            })
                        )
                    }
                }
                if (authenticationtype.length === 1) {
                    setFormData('authenticationtype', {
                        authenticationtypeid: authenticationtype[0].authenticationtypeid,
                        name: authenticationtype[0].name,
                    })
                }
            }
        }
        if (programId) callApi()
        else {
            if (
                !((props.openProgramDialog && props.dialogProgramId) || props.programEdit)
            ) {
                setAuthenticationTypeData([])
                setFormData('authenticationtype', {})
            }
        }
    }

    if (formFields) {
        formFields.map(data => {
            _.map(data.value, data1 => {
                if (data1.columnName === 'loginname') {
                    data1.maxLength = loginMaxLength
                }
                if (
                    data1.columnName === 'authenticationtype' &&
                    !myAccountSchema.is_hide_auth_type
                ) {
                    data1.data =
                        authenticationTypeData.length > 0 ? authenticationTypeData : []
                    data1.isHide = authenticationTypeData.length > 1 ? false : true
                }
                if (data1.columnName === 'userrole') {
                    data1.multiSelect = multiselectRole
                }
                if (data1.componentType === 'MarkdownRender') {
                    if (programCustomMsg) {
                        data1.isHide = false
                        data1.value = programCustomMsg.msg
                    } else {
                        data1.isHide = true
                    }
                }
                if (
                    props.sectionProps &&
                    props.sectionProps.accessFormStruct.multifaProgramObject
                ) {
                    if (data1.columnName === 'multifa') {
                        if (multifaField) {
                            data1.isHide = multifaField.isHide
                            data1.isDisabled = multifaField.isDisabled
                        } else {
                            data1.isHide = true
                        }
                    }
                }
                if (data1.dependentKey) {
                    if (
                        data1.dependentKey.includes('clientprogram') &&
                        (programChange ||
                            (formData.clientprogram &&
                                formData.clientprogram.clientprogramid))
                    ) {
                        data1.dependentKeyval = {
                            'client-program-id': formData.clientprogram.clientprogramid
                                ? formData.clientprogram.clientprogramid
                                : programChange,
                        }
                    } else {
                        data1.dependentKeyval = {}
                    }
                }
            })
        })
    }

    return (
        <Grid container spacing={3} className="program__custom-message-main">
            <Grid item xs={12} className="program__custom-message">
                <FormBuilder
                    fields={formFields}
                    formData={formData}
                    setFormData={setFormData}
                    errorsData={errorsData}
                    updateValidation={updateValidationData}
                    actionMethods={actionMethods}
                    // loading={loading}
                    // setFormDataChanged={setFormDataChanged}
                />
            </Grid>
            <Grid item xs={12} className="um-organization-main__wrapper">
                {props.organization
                    .filter(o => !o.isdeleted)
                    .map(obj => {
                        const organizationFormSchema = props.organizationFormStruct.map(
                            item => {
                                const _val = item.value.map(val => {
                                    if (
                                        obj.organizationaccessid &&
                                        val.fieldName === 'Organization'
                                    ) {
                                        if (val.hasOwnProperty('disabled'))
                                            return {...val, disabled: true}
                                        else return {...val, isDisabled: true}
                                    } else return {...val}
                                })
                                return {...item, value: _val}
                            }
                        )
                        return (
                            <OrganizationSectionForm
                                fields={organizationFormSchema}
                                obj={obj}
                                org={props.organization}
                                validateTrigger={obj.validateTrigger}
                                actionFrom={props.actionFrom}
                                handleAddNewOrganization={props.handleAddNewOrganization}
                                removeOrganization={props.removeOrganization}
                                addFormData={props.addFormData}
                                userid={props.userid}
                                clientProgramId={programChange}
                                actionMethods={actionMethods}
                                programEdit={props.programEdit}
                                openProgramDialog={props.openProgramDialog}
                                dialogProgramId={props.dialogProgramId}
                                userDetails={props.userDetails}
                            />
                        )
                    })}
            </Grid>
            {organizationData &&
                Array.isArray(organizationData) &&
                organizationData.length > 1 &&
                organizationData.length !==
                    props.organization.filter(o => !o.isdeleted).length && (
                    <Grid item xs={12}>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<AddIcon />}
                            fullWidth
                            onClick={() => props.handleAddNewOrganization(formData)}
                        >
                            Add another organization
                        </Button>
                    </Grid>
                )}
        </Grid>
    )
}

const SectionPanel = props => {
    const sections = props.content

    const schemaProgramAccess = props.sectionProps
    ///edit program check
    if ((props.openProgramDialog && props.dialogProgramId) || props.programEdit) {
        const progrId = props.openProgramDialog
            ? props.dialogProgramId
            : props.programEdit
        if (progrId && Number.isInteger(progrId)) props.setActiveSection(progrId)
        schemaProgramAccess.accessFormStruct.fields = schemaProgramAccess.accessFormStruct.fields.map(
            item => {
                const _val = item.value.map(val => {
                    if (
                        val.fieldName === 'Program' ||
                        val.fieldName === 'Program Login Name'
                    ) {
                        if (val.hasOwnProperty('disabled'))
                            return {...val, disabled: true}
                        else return {...val, isDisabled: true}
                    } else return {...val}
                })
                return {...item, value: _val}
            }
        )
    }
    const [sectionState, setSectionState] = useState([])
    useEffect(() => {
        const sectionsArr = []
        sections.forEach(element => {
            const obj = {name: element.sectionname, isExpanded: true}
            sectionsArr.push(obj)
        })

        setSectionState(sectionsArr)
    }, [])

    const updateSectionState = e => {
        props.setActiveSection(e)
    }

    useEffect(() => {
        if (sections.length) {
            props.setActiveSection(sections[sections.length - 1].accessId)
        }
    }, [sections.length])

    return (
        <>
            {/* {sections.map((obj, index) => {
                return ( */}
            <Grid container className="accordion_master-content__row">
                {sections.length > 1 && (
                    <Grid item xs={1} className="accordion_master-content__grid">
                        <Divider orientation="vertical" flexItem />
                    </Grid>
                )}
                {sections.length > 0 && (
                    <Grid item xs className="accordion_master-content__grid">
                        <ExpandingPanelForm
                            fields={schemaProgramAccess.accessFormStruct.fields}
                            organizationFormStruct={
                                schemaProgramAccess.organizationFormStruct.fields
                            }
                            validateTrigger={sections[0].validateTrigger}
                            actionFrom={sections[0].actionFrom}
                            obj={sections[0]}
                            setValidateTrigger={props.setValidateTrigger}
                            handleAddNewOrganization={props.handleAddNewOrganization}
                            removeOrganization={props.removeOrganization}
                            handleProvideAccess={props.handleProvideAccess}
                            handleSave={props.handleSave}
                            organization={sections[0].organization}
                            addFormData={props.addFormData}
                            userid={props.userid}
                            accessData={props.accessData}
                            activeSection={props.activeSection}
                            savedProgramList={
                                (props.savedProgramList && props.savedProgramList) || null
                            }
                            sectionProps={props.sectionProps}
                            setDialogSectionData={
                                (props.setDialogSectionData &&
                                    props.setDialogSectionData) ||
                                null
                            }
                            programEdit={props.programEdit}
                            openProgramDialog={props.openProgramDialog}
                            dialogProgramId={props.dialogProgramId}
                            cancelProgramDialog={props.cancelProgramDialog}
                            setRouter={props.setRouter}
                            ADLoginName={props.ADLoginName}
                            userDetails={props.userDetails}
                            setAccessData={props.setAccessData}
                        />
                    </Grid>
                )}
            </Grid>
            {/* )
            })} */}
        </>
    )
}

const UserAccess = props => {
    const useStyles = makeStyles(theme => ({
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    }))

    const classes = useStyles()

    const {showToast} = useContext(ToastContext)
    const {clientObject, setClientObject, resourceObject, myAccountSchema} = useContext(
        MyAccountContext
    )
    let formContent = myAccountSchema.myAccountSchema.filter(
        element => element.componentType.toLowerCase() === 'adduser'
    )
    formContent = Array.isArray(formContent) && JSON.stringify(formContent[0])
    formContent = JSON.parse(formContent)
    const sections =
        (formContent.sections &&
            Array.isArray(formContent.sections) &&
            formContent.sections[0]) ||
        []

    let organizationFormStruct =
        (formContent.sections &&
            Array.isArray(formContent.sections) &&
            formContent.sections.length > 1 &&
            formContent.sections[1]) ||
        []
    const accessFormStruct =
        sections.mastersectiondetails && sections.mastersectiondetails.length > 0
            ? sections.mastersectiondetails[0].jsonschema
            : []
    organizationFormStruct =
        organizationFormStruct.mastersectiondetails &&
        organizationFormStruct.mastersectiondetails.length > 0
            ? organizationFormStruct.mastersectiondetails[0].jsonschema
            : []

    const sectionProps = {
        accessFormStruct: JSON.parse(JSON.stringify(accessFormStruct)),
        organizationFormStruct: JSON.parse(JSON.stringify(organizationFormStruct)),
        programColumns: accessFormStruct.programColumns,
    }
    const newprogramaccess = [
        {
            accessId: 1,
            isExpanded: true,
            name: 'Access 1',
            formData: {
                authenticationtype: {},
                clientprogram: {},
                loginname: '',
                multifa: {
                    value: false,
                    label: 'No',
                    obj: {value: false, label: 'No'},
                },
                userrole: {},
            },
            organization: [
                {
                    orgId: 1,
                    isdeleted: false,
                    formData: {
                        inactive: true,
                        cliententity: {},
                        clinicians: 'all',
                        locations: 'all',
                        eds: 'all',
                    },
                },
            ],
            validateTrigger: false,
        },
    ]

    const [accessData, setAccessData] = useState(
        JSON.parse(JSON.stringify(newprogramaccess))
    )
    const [dialogAccessData, setDialogAccessData] = useState(
        JSON.parse(JSON.stringify(newprogramaccess))
    )

    const [openCofirmation, setOpenCofirmation] = useState(false)
    const [deleteOrgId, setDeleteOrgId] = useState(null)
    const [deleteProgramId, setDeleteProgramId] = useState(null)
    const [confirmationFor, setConfirmationFor] = useState('')
    const [loading, setLoading] = useState(false)
    const [pageLoading, setPageLoading] = useState(false)
    const [activeSection, setActiveSection] = useState(accessData[0].accessId)
    const [targetSection, setTargetSection] = useState('')
    const [isEditPage, setIsEditPage] = useState(false)
    const [isMultiProgram, setIsMultiProgram] = useState(false)
    const [programCount, setProgramCount] = useState(0)
    const [tableLength, setTableLength] = useState(0)
    const [showAddProgram, setShowAddProgram] = useState(false)
    const [tableData, setTableData] = useState([])
    const [tableAllData, setTableAllData] = useState([])
    const [tableProperties, setTableProperties] = useState({
        order: 'asc',
        orderBy: '',
        rowsPerPage: 10,
        activePage: 0,
    })

    const [savedProgramList, setSavedProgramList] = useState([])
    const [openProgramDialog, setOpenProgramDialog] = useState(false)
    const [programId, setProgramId] = useState('')
    const [dialogProgramId, setDialoagProgramId] = useState(false)
    const [dialogSectionData, setDialogSectionData] = useState(sectionProps)
    const [sectionSchema, setSectionSchema] = useState(sectionProps)
    const [ADLoginName, setADLoginName] = useState('')
    const [isAddNewUserAccess, setIsAddNewUserAccess] = useState(true)
    const [isUpdateUserAccess, setIsUpdateUserAccess] = useState(true)
    const [isDeleteUserAccess, setIsDeleteUserAccess] = useState(true)

    const getUserDetails = userid => {
        const callApi = async () => {
            var apiData = await getClientProgramAPIData(
                'cliententity/user/' + userid,
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                }
            )
            if (apiData && apiData.userdetails) {
                managePage(apiData.userdetails)
                props.updateUserDetails(apiData.userdetails)
            }
        }
        callApi()
    }

    const managePage = uDetails => {
        let userData = []
        if (uDetails && uDetails.adloginname) setADLoginName(uDetails.adloginname)
        if (
            uDetails &&
            uDetails.programaccess &&
            Array.isArray(uDetails.programaccess) &&
            uDetails.programaccess.length
        ) {
            let tempTableData = [...uDetails.programaccess]
            uDetails.programaccess.map((tData, tDataIndex) => {
                let rolename =
                    tData.role && Array.isArray(tData.role)
                        ? tData.role
                              .map(item => {
                                  return item.rolename
                              })
                              .join(', ')
                        : tData.role.rolename

                tempTableData[tDataIndex] = {
                    ...tempTableData[tDataIndex],
                    rolename: rolename,
                }
            })

            setTableData(tempTableData)
            setTableAllData(uDetails.programaccess)
            setTableLength(uDetails.programaccess.length)
            if (uDetails.programaccess.length > 1) setIsMultiProgram(true)
            if (uDetails.programaccess.length === 1)
                setProgramId(uDetails.programaccess[0].clientprogram.clientprogramid)

            var clientprogramList = []
            const callFun = async () => {
                await uDetails.programaccess.map((access, index) => {
                    clientprogramList.push(access.clientprogram.clientprogramid)

                    let userrole = {}
                    if (
                        access.role &&
                        Array.isArray(access.role) &&
                        access.role.length > 0
                    ) {
                        userrole = []
                        access.role.map(roles => {
                            userrole.push({
                                clientprogramrolemappingid:
                                    roles.clientprogramrolemappingid,
                                name: roles.rolename,
                            })
                        })
                    } else {
                        userrole = {
                            clientprogramrolemappingid:
                                access.role.clientprogramrolemappingid,
                            name: access.role.rolename,
                        }
                    }
                    let newUserData = {
                        accessId: access.clientprogram.clientprogramid,
                        isExpanded: true,
                        name: 'Access ' + index + 1,
                        formData: {
                            authenticationtype: {
                                authenticationtypeid:
                                    access.authenticationtype &&
                                    access.authenticationtype.authenticationtypeid,
                                name:
                                    access.authenticationtype &&
                                    access.authenticationtype.authenticationtypename,
                            },
                            clientprogram: {
                                clientprogramid: access.clientprogram.clientprogramid,
                                name: access.clientprogram.clientprogramname,
                                allowmultipleroleselect:
                                    access.clientprogram.allowmultipleroleselect,
                            },
                            loginname: access.loginname,
                            multifa: {
                                value: access.twofa,
                                label: !access.twofa ? 'No' : 'Yes',
                            },
                            userrole: userrole,
                        },
                        organization: [],
                        validateTrigger: false,
                    }
                    access.organizationaccess.map((organization, index) => {
                        let newOrganization = {
                            orgId: index + 1,
                            organizationaccessid: organization.organizationaccessid,
                            isdeleted: false,
                            formData: {
                                inactive: !organization.inactive,
                                cliententity: {
                                    cliententityid:
                                        organization.cliententity.cliententityid,
                                    name:
                                        organization.cliententity.practiceid +
                                        ' - ' +
                                        organization.cliententity.cliententityname,
                                },
                                clinicians: organization.clinicianlist
                                    ? organization.clinicianlist
                                    : 'all',
                                locations: organization.locationlist
                                    ? organization.locationlist
                                    : 'all',
                                eds: organization.edlist ? organization.edlist : 'all',
                            },
                            validateTrigger: false,
                        }
                        newUserData.organization.push(newOrganization)
                    })
                    userData.push(newUserData)
                })
            }
            callFun()
            setAccessData(userData)
            setSavedProgramList(clientprogramList)
            setIsEditPage(true)
        }
    }

    useEffect(() => {
        if (props.savedProgram.openProgramDialog) {
            openDialog()
            if (openProgramDialog) {
                setDialoagProgramId('')
            }
            props.setSavedProgram({
                openProgramDialog: false,
                userid: '',
            })
            if (props.savedProgram.clientprogramid) {
                let listObj = []
                listObj.push(props.savedProgram.clientprogramid)
                setSavedProgramList(listObj)
            }
        } else if (!props.savedProgram.openProgramDialog && props.savedProgram.userid) {
            //after dialog save
            getUserDetails(props.savedProgram.userid)
        }
    }, [props.savedProgram])

    useEffect(() => {
        managePage(props.userDetails)
    }, [props.userDetails])

    useEffect(() => {
        setShowAddProgram(false)
        if (programCount > 0) {
            if (tableLength > 0) {
                if (programCount !== tableLength) setShowAddProgram(true)
            } else setShowAddProgram(true)
        }
    }, [tableLength, programCount])
    useEffect(() => {
        const callApi = async () => {
            var apiData = await getAPIData(
                'user/program',
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                }
            )

            if (apiData && apiData.programs) {
                setProgramCount(apiData.programs.length)
                if (apiData.programs.length > 1)
                    setIsMultiProgram && setIsMultiProgram(true)
                //-----------------------------
                // const programData = apiData.programs
                // // setProgramData(programData)
                // if (programData.length > 0) {
                //     props.setIsMultiProgram && props.setIsMultiProgram(true)
                // }
                // // if (props.savedProgramList) {
                // let filterData =
                //     programData
                //         .filter(p => savedProgramList.indexOf(p.value) === -1 && p)
                //         .map(s => {
                //             return {value: s.clientprogramid, label: s.name, obj: {...s}}
                //         }) || []
                // let setData = sectionSchema
                // setData.accessFormStruct.fields[0].value[0].fetchData = false
                // setData.accessFormStruct.fields[0].value[0].data = filterData
                // setSectionSchema(setData) //setDialogSectionData(setData)
                // //-----------------
                // setProgramCount(programData.length)
                // if (programData.length > 1) setIsMultiProgram && setIsMultiProgram(true)
            }
        }
        callApi()
        accessController()
    }, [])

    useEffect(() => {
        if (tableLength <= 1) {
            setProgramId(
                accessData[0].formData.clientprogram.clientprogramid
                    ? accessData[0].formData.clientprogram.clientprogramid
                    : ''
            )
        }
    }, [tableLength])

    useEffect(() => {
        accessController()
    }, [resourceObject])

    const accessController = () => {
        if (resourceObject['isPolicyBased']) {
            if (
                resourceObject['resource'] &&
                resourceObject['resource'].resource === 'MyAccount Application' &&
                resourceObject['resource'].childs &&
                resourceObject['resource'].childs.length > 0
            ) {
                let userAccess = resourceObject['resource'].childs.filter(
                    value => value.resource === 'User'
                )

                if (userAccess && userAccess.length > 0) {
                    let action = userAccess[0].actions
                    let actions = action.split(',')

                    actions.includes('Create')
                        ? setIsAddNewUserAccess(true)
                        : setIsAddNewUserAccess(false)
                    actions.includes('Delete')
                        ? setIsDeleteUserAccess(true)
                        : setIsDeleteUserAccess(false)
                    if (props.userid) {
                        if (actions.includes('Update')) setIsUpdateUserAccess(true)
                        else {
                            setIsUpdateUserAccess(false)
                            setIsAddNewUserAccess(false)
                        }
                    } else setIsUpdateUserAccess(true)
                } else {
                    setIsAddNewUserAccess(false)
                    setIsUpdateUserAccess(false)
                    setIsDeleteUserAccess(false)
                }
            } else {
                setIsAddNewUserAccess(false)
                setIsUpdateUserAccess(false)
                setIsDeleteUserAccess(false)
            }
        }
    }

    const handleSave = (isValidProgram = false, programAccess) => {
        let isDuplicate = false
        let dataObject = (openProgramDialog && dialogAccessData) || accessData
        let datSetObject = (openProgramDialog && setDialogAccessData) || setAccessData
        const data = dataObject.map(function(o) {
            if (o.accessId === activeSection) {
                let isValidCount = 0
                o.organization.forEach(item => {
                    if (item.isValid) isValidCount += 1
                })

                const valueArr = o.organization
                    .filter(o => !o.isdeleted)
                    .map(function(o) {
                        return o.formData.cliententity.cliententityid
                    })
                isDuplicate = valueArr.some(function(item, idx) {
                    return valueArr.indexOf(item) !== idx
                })
                isValidProgram =
                    isValidProgram &&
                    (Array.isArray(programAccess) ||
                        isValidCount ===
                            o.organization.filter(o => !o.isdeleted).length) &&
                    !isDuplicate
            }

            return {
                ...o,
                formData:
                    o.accessId === activeSection && !Array.isArray(programAccess)
                        ? programAccess
                        : o.formData,
                validateTrigger: o.accessId === activeSection ? false : o.validateTrigger,
            }
        })

        datSetObject(data)
        if (isDuplicate) {
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message: 'Duplicate organization selected.',
            })
        } else props.updateMainContainerValidate('save', isValidProgram, data)
        setValidateTrigger(true, '', '')
    }

    const setValidateTrigger = (reset = false, actionFrom = '', targetSection) => {
        setTargetSection(targetSection)

        let dataObject = (openProgramDialog && dialogAccessData) || accessData
        let dataSetObject = (openProgramDialog && setDialogAccessData) || setAccessData
        if (actionFrom === 'usersave' && dataObject.length > 1)
            handleSave(true, dataObject)
        else {
            const data = dataObject.map(function(o) {
                let orgObj
                if (o.accessId === activeSection) {
                    orgObj = o.organization.map(org => {
                        return {
                            ...org,
                            validateTrigger: !o.isdeleted
                                ? reset
                                    ? false
                                    : true
                                : false,
                        }
                    })
                }

                return {
                    ...o,
                    validateTrigger:
                        o.accessId === activeSection ? (reset ? false : true) : false,
                    actionFrom: o.accessId === activeSection ? actionFrom : '',
                    organization: orgObj ? orgObj : o.organization,
                }
            })
            dataSetObject(data)
        }
    }

    const handleAddNewOrganization = programFormData => {
        let dataObject
        if (!openProgramDialog) dataObject = accessData
        else dataObject = dialogAccessData

        const data = dataObject.map(function(o) {
            if (o.accessId === activeSection) {
                let maxOrgId = Math.max.apply(
                    Math,
                    o.organization.map(function(o) {
                        return o.orgId
                    })
                )

                const newobj = [
                    {
                        orgId: maxOrgId + 1,
                        isdeleted: false,
                        formData: {
                            inactive: true,
                            cliententity: {},
                            clinicians: 'all',
                            locations: 'all',
                            eds: 'all',
                        },
                        validateTrigger: false,
                    },
                ]
                //setActiveOrg(newobj[0].orgId)
                return {
                    ...o,
                    formData: o.accessId === activeSection ? programFormData : o.formData,
                    validateTrigger:
                        o.accessId === activeSection ? false : o.validateTrigger,
                    organization: [...o.organization, ...newobj],
                }
            } else return {...o}
        })

        if (!openProgramDialog) setAccessData([...data])
        else setDialogAccessData([...data])
    }

    const handleProvideAccess = async (
        actionFrom = 'newaccess',
        isValidProgram = false,
        submitData
    ) => {
        let dataObject
        if (!openProgramDialog) dataObject = accessData
        else dataObject = dialogAccessData

        let isDuplicate = false
        const data = dataObject.map(function(o) {
            if (o.accessId === activeSection) {
                let isValidCount = 0
                o.organization.forEach(item => {
                    if (item.isValid) isValidCount += 1
                })
                const valueArr = o.organization
                    .filter(o => !o.isdeleted)
                    .map(function(o) {
                        return o.formData.cliententity.cliententityid
                    })
                isDuplicate = valueArr.some(function(item, idx) {
                    return valueArr.indexOf(item) !== idx
                })
                isValidProgram =
                    isValidProgram &&
                    isValidCount === o.organization.filter(o => !o.isdeleted).length &&
                    !isDuplicate
            }

            return {
                ...o,
                formData: o.accessId === activeSection ? submitData : o.formData,
                validateTrigger: o.accessId === activeSection ? false : o.validateTrigger,
            }
        })

        if (isDuplicate) {
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message: 'Duplicate organization selected.',
            })
        } else {
            props.updateMainContainerValidate(actionFrom, isValidProgram, data)
            if (actionFrom === 'saveaccess' && isValidProgram) cancelProgramDialog()
        }
        setValidateTrigger(true, '', '')

        if (!openProgramDialog) setAccessData([...data])
        else setDialogAccessData([...data])
    }

    const removeOrganization = orgId => {
        setOpenCofirmation(true)
        setDeleteOrgId(orgId)
        setConfirmationFor('org')
    }

    const deleteOrganization = orgId => {
        let dataObj = (openProgramDialog && dialogAccessData) || accessData
        let status = false
        const data = dataObj.map(function(o) {
            // let orgObj
            if (o.accessId === activeSection) {
                const index = o.organization
                    .map(function(e) {
                        return e.orgId
                    })
                    .indexOf(orgId)
                o.organization = o.organization.map(oitem => {
                    return oitem.orgId === orgId
                        ? {...oitem, isdeleted: true, isValid: false}
                        : oitem
                })

                if (index > -1) {
                    //o.organization.splice(index, 1)
                    status = true
                } else status = false
            }
            return {...o}
        })
        if (openProgramDialog) setDialogAccessData(data)
        else setAccessData(data)

        // showToast({
        //     open: true,
        //     variant: status ? TOAST_VARIANT.SUCCESS : TOAST_VARIANT.ERROR,
        //     message: status
        //         ? 'Organization deleted successfully.'
        //         : // i18next.t(
        //           //       'milestone.practiceDetails.tinInformation.deleteTinAction.success'
        //           //   )
        //           'Organization not found.',
        //     // i18next.t(
        //     //       'milestone.practiceDetails.tinInformation.deleteTinAction.error'
        //     //   ),
        // })
    }

    const addFormData = (orgId, formData, isValid) => {
        let newAccessData = (openProgramDialog && dialogAccessData) || accessData
        newAccessData.map(access => {
            if (access.accessId === activeSection) {
                access.validateTrigger = false
                if (orgId) {
                    access.organization.map(organization => {
                        if (organization.orgId === orgId) {
                            organization.formData = formData
                            organization.validateTrigger = false
                            organization.isValid = isValid
                        }
                    })
                } else {
                    access.formData = formData
                }
            }
        })
        //}

        if (openProgramDialog) setDialogAccessData(newAccessData)
        else setAccessData(newAccessData)
    }

    if (pageLoading) return <Loader type="page" />
    if (!sectionProps) return 'Work in progress'

    const tableActionMethod = async (e, header) => {
        if (e.actionType === 'edit') {
            var userData = []
            let access = e.row

            let setData = _.cloneDeep(dialogSectionData)
            set(
                setData.accessFormStruct,
                setData.accessFormStruct.programdropdownpath + '.isDisabled',
                true
            )
            setDialogSectionData(setData)
            setDialoagProgramId(access.clientprogram.clientprogramid)

            let userrole = {}
            if (
                // access.clientprogram &&
                // access.clientprogram.allowmultipleroleselect &&
                access.role &&
                Array.isArray(access.role) &&
                access.role.length > 0
            ) {
                userrole = []
                access.role.map(roles => {
                    userrole.push({
                        clientprogramrolemappingid: roles.clientprogramrolemappingid,
                        name: roles.rolename,
                    })
                })
            } else {
                userrole = {
                    clientprogramrolemappingid: access.role.clientprogramrolemappingid,
                    name: access.role.rolename,
                }
            }
            let newUserData = {
                accessId: access.clientprogram.clientprogramid,
                isExpanded: true,
                name: 'Access ' + 1,
                formData: {
                    authenticationtype: {
                        authenticationtypeid:
                            access.authenticationtype &&
                            access.authenticationtype.authenticationtypeid,
                        name:
                            access.authenticationtype &&
                            access.authenticationtype.authenticationtypename,
                    },
                    clientprogram: {
                        clientprogramid: access.clientprogram.clientprogramid,
                        name: access.clientprogram.clientprogramname,
                        allowmultipleroleselect:
                            access.clientprogram.allowmultipleroleselect,
                    },
                    loginname: access.loginname,
                    multifa: {
                        // value: access.authenticationtypeid,
                        // label: !access.authenticationtypeid ? 'No' : 'Yes',
                        value: access.twofa,
                        label: !access.twofa ? 'No' : 'Yes',
                    },
                    userrole: userrole,
                },
                organization: [],
                validateTrigger: false,
            }
            access.organizationaccess.map((organization, index) => {
                let newOrganization = {
                    orgId: index + 1,
                    organizationaccessid: organization.organizationaccessid,
                    isdeleted: false,
                    formData: {
                        inactive: !organization.inactive,
                        cliententity: {
                            cliententityid: organization.cliententity.cliententityid,
                            name:
                                organization.cliententity.practiceid +
                                ' - ' +
                                organization.cliententity.cliententityname,
                        },
                        clinicians: organization.clinicianlist,
                        locations: organization.locationlist,
                        eds: organization.edlist,
                    },
                    validateTrigger: false,
                }
                newUserData.organization.push(newOrganization)
            })
            userData.push(newUserData)

            setDialogAccessData(userData)
            setOpenProgramDialog(true)
        } else if (e.actionType === 'delete') {
            setOpenCofirmation(true)
            setDeleteProgramId(e.row.clientprogram.clientprogramid)
            setConfirmationFor('program')
        }
    }

    const deleteProgramAPI = clientprogramid => {
        const callApi = async () => {
            const deleteUserID =
                (props.userid && props.userid) || props.savedProgram.userid
            var apiData = await deleteAPIData(
                'user/programaccess/' + deleteUserID,
                {},
                {
                    'client-program-id': clientprogramid,
                    'client-entity-id': clientObject.cliententityid,
                }
            )
            if (apiData) {
                // props.setIsRefresh(!props.isRefresh)
                getUserDetails(deleteUserID)
            }
            showToast({
                open: true,
                variant: apiData ? TOAST_VARIANT.SUCCESS : TOAST_VARIANT.ERROR,
                message:
                    (apiData && 'Program Deleted Successfully!') || 'Program Not Deleted',
            })
            setPageLoading(false)
            setLoading(false)
        }
        callApi()
    }

    const cancelProgramDialog = e => {
        //setProgramId('')
        if (props.userid) {
            props.setUserId(props.userid)
        }
        if (openProgramDialog) {
            setDialoagProgramId('')
        }
        if (accessData && accessData.length === 1) {
            setActiveSection(accessData[0].accessId)
        }
        setValidateTrigger(true, '', '')
        setOpenProgramDialog(false)
    }

    const openDialog = e => {
        var userData = []
        let maxAccess = Math.max.apply(
            Math,
            accessData.map(function(o) {
                return o.accessId
            })
        )
        setActiveSection(maxAccess + 1)
        let newObj = {
            accessId: maxAccess + 1,
            isExpanded: true,
            name: 'Access 1',
            formData: {
                authenticationtype: {},
                clientprogram: {},
                loginname: '',
                multifa: {
                    value: false,
                    label: 'No',
                    obj: {value: false, label: 'No'},
                },
                userrole: {},
            },
            organization: [
                {
                    orgId: 1,
                    isdeleted: false,
                    formData: {
                        inactive: true,
                        cliententity: {},
                        clinicians: 'all',
                        locations: 'all',
                        eds: 'all',
                    },
                    userrole: {},
                },
            ],
            validateTrigger: false,
        }
        userData.push(newObj)

        setDialogAccessData(userData)
        setOpenProgramDialog(true)
    }
    const clickAnotherProgram = e => {
        if (tableLength > 0) {
            setDialogSectionData(sectionProps)
            openDialog()
            if (openProgramDialog) {
                setDialoagProgramId('')
            }
        } else setValidateTrigger(false, 'newaccess', '')
    }

    const closeConfirmation = () => {
        setOpenCofirmation(false)
    }

    const confirmAction = () => {
        setOpenCofirmation(false)
        if (confirmationFor === 'org') deleteOrganization(deleteOrgId)
        else if (confirmationFor === 'program') deleteProgramAPI(deleteProgramId)
    }

    !isDeleteUserAccess &&
        sectionProps.programColumns.map(e => {
            if (e.mapProperty === 'actions') {
                e.columnActions.map(c => {
                    if (c.actionType === 'delete') return (c.clientSideDisable = true)
                })
            }
        })

    return (
        <Grid
            container
            spacing={3}
            className="user-manage-main__wrapper section-details__wrapper"
        >
            {accessData && accessData.length === 1 && (
                <Grid item xs>
                    <Typography variant="h5" className="accordion_title_h5">
                        Program Information
                    </Typography>
                </Grid>
            )}
            {tableLength > 1 && GlobalSetting.IS_MULTIPROGRAM && (
                <Grid
                    item
                    xs={12}
                    className="accordion-content__container user-manage-section__wrapper"
                >
                    <TableBuilder
                        tableData={tableData}
                        columns={sectionProps.programColumns}
                        tableDataCount={tableAllData.length}
                        pageList={pageList}
                        tableProperties={tableProperties}
                        setTableProperties={setTableProperties}
                        actionMethod={tableActionMethod}
                    />
                </Grid>
            )}

            <Dialog
                className={`main-dialogbox__wrapper add-um-practice__dialog ${props.cssClass}`}
                open={openProgramDialog}
                fullWidth
                maxWidth="xl"
                aria-labelledby="max-width-dialog-title"
            >
                <>
                    <DialogTitle
                        id="form-dialog-title"
                        className="edit-modal-wrapper__title"
                    >
                        <Grid className="modal-title-header">
                            <Typography variant="h6" className="modal-title">
                                Program Information
                                <IconButton
                                    aria-label="close"
                                    className={clsx(classes.closeButton + ' close-icon')}
                                    onClick={() => cancelProgramDialog()}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Typography>
                        </Grid>
                    </DialogTitle>
                    <DialogContent className="dialog-content__wrapper user-manage-section__wrapper">
                        <Grid
                            item
                            xs={12}
                            md
                            className={`input-field__main_container ${props.cssClass}`}
                        >
                            <SectionPanel
                                content={dialogAccessData}
                                accessData={accessData}
                                setAccessData={setDialogAccessData}
                                sectionProps={dialogSectionData}
                                setDialogSectionData={setDialogSectionData}
                                setActiveSection={setActiveSection}
                                activeSection={activeSection}
                                handleProvideAccess={handleProvideAccess}
                                handleAddNewOrganization={handleAddNewOrganization}
                                removeOrganization={removeOrganization}
                                handleSave={handleSave}
                                setValidateTrigger={setValidateTrigger}
                                targetSection={targetSection}
                                addFormData={addFormData}
                                userid={props.userid}
                                openProgramDialog={openProgramDialog}
                                dialogProgramId={dialogProgramId}
                                savedProgramList={savedProgramList}
                                cancelProgramDialog={cancelProgramDialog}
                                setRouter={props.setRouter}
                                ADLoginName={ADLoginName}
                                userDetails={props.userDetails}
                            ></SectionPanel>
                        </Grid>
                    </DialogContent>
                    <DialogActions className="dialog-footer__wrapper">
                        <Button
                            key={1}
                            onClick={() => cancelProgramDialog()}
                            color="primary"
                            type="submit"
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setValidateTrigger(false, 'saveaccess', '')}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </>
            </Dialog>
            {(tableLength <= 1 || !GlobalSetting.IS_MULTIPROGRAM) && (
                <Grid
                    item
                    xs={12}
                    className="accordion-content__container user-manage-section__wrapper"
                >
                    <Grid item className="um-organization-main__wrapper">
                        {loading && <Loader type="center-overlay" />}
                        <SectionPanel
                            content={accessData}
                            accessData={accessData}
                            setAccessData={setAccessData}
                            sectionProps={sectionProps}
                            setActiveSection={setActiveSection}
                            activeSection={activeSection}
                            handleProvideAccess={handleProvideAccess}
                            handleAddNewOrganization={handleAddNewOrganization}
                            removeOrganization={removeOrganization}
                            handleSave={handleSave}
                            setValidateTrigger={setValidateTrigger}
                            targetSection={targetSection}
                            addFormData={addFormData}
                            userid={props.userid}
                            programEdit={programId}
                            openProgramDialog={openProgramDialog}
                            setSavedProgramList={setSavedProgramList}
                            cancelProgramDialog={cancelProgramDialog}
                            setRouter={props.setRouter}
                            ADLoginName={ADLoginName}
                            userDetails={props.userDetails}
                        ></SectionPanel>
                    </Grid>
                </Grid>
            )}

            <Grid container spacing={3}>
                <Grid item xs alignContent="right" className="right-btn__container">
                    {isMultiProgram &&
                        GlobalSetting.IS_MULTIPROGRAM &&
                        showAddProgram === true && (
                            <>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={() =>
                                        tableLength > 1
                                            ? clickAnotherProgram()
                                            : setValidateTrigger(false, 'newaccess', '')
                                    }
                                    //onClick={() => clickAnotherProgram()}
                                    disabled={!isAddNewUserAccess}
                                >
                                    {(tableLength > 1 && 'Add another program') ||
                                        'Save and Add another program'}
                                </Button>
                                <Divider orientation="vertical" flexItem />
                            </>
                        )}

                    <Button
                        variant="outlined"
                        color="default"
                        onClick={() => {
                            setClientObject({
                                ...clientObject,
                                loadpreventusergrid: 1,
                            })
                            props.setRouter(props.backrouter || 'user')
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setValidateTrigger(false, 'usersave', '')}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            {openCofirmation && (
                <ConfirmationBox
                    open={openCofirmation}
                    closeDialog={closeConfirmation}
                    confirmAction={confirmAction}
                    // message="Are you sure you want to delete it?"
                    // confirmButton="Yes"
                    // rejectButton="No"
                    message={i18next.t(
                        confirmationFor === 'org'
                            ? 'myaccount.userManagement.confirmDialog.orgTextMessage'
                            : 'myaccount.userManagement.confirmDialog.programTextMessage'
                    )}
                    confirmButton={i18next.t(
                        'myaccount.userManagement.confirmDialog.confirmButton'
                    )}
                    rejectButton={i18next.t(
                        'myaccount.userManagement.confirmDialog.rejectButton'
                    )}
                />
            )}
        </Grid>
    )
}
export default UserAccess
